var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53977 8.94664L2.29364 8.94664C1.28056 8.94664 0.621653 7.88051 1.07472 6.97438L3.45961 2.20459C3.69046 1.7429 4.16234 1.45126 4.67853 1.45126L7.4162 1.45126C7.52763 1.45126 7.63863 1.46492 7.74673 1.49195L10.3096 2.13266M5.53977 8.94664L5.53977 12.3536C5.53977 13.1063 6.14992 13.7164 6.90257 13.7164L6.96763 13.7164C7.30802 13.7164 7.58397 13.4405 7.58397 13.1001C7.58397 12.6134 7.72804 12.1375 7.99803 11.7325L10.3096 8.26524L10.3096 2.13266M5.53977 8.94664L6.90257 8.94664M10.3096 2.13266L11.6724 2.13266C12.425 2.13266 13.0352 2.7428 13.0352 3.49545L13.0352 7.58384C13.0352 8.3365 12.425 8.94664 11.6724 8.94664L9.96886 8.94664",
    stroke: "#111827",
    strokeWidth: 1.3628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.599529abf281869ed964b5d6dda84863.svg";
export { ForwardRef as ReactComponent };